import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import SocialIcons, { SocialIcon } from 'tbk-components/src/components/SocialIcons';
export interface IShareOnProps extends IBaseElementProps {
	heading?: string;
	socialIcons?: SocialIcon[];
}

/**
 * Share On
 * @block
 * @requiresHooks
 * @icon share
 */

const ShareOn: React.FC<IShareOnProps> = ({
	className,
	heading,
	socialIcons = [],
}) => (
	<div className={className || cn('share-on', className)}>
		{heading && <h4 className="share-on__heading">{heading}</h4>}
		{Array.isArray(socialIcons) && <div className="share-on__social"><SocialIcons icons={socialIcons} /></div>}
	</div>
);

export default ShareOn;
